(function componentForm($, Adzuki)
{
	"use strict";

	var form   = {
		name: 'AgentInvoiceSpecificNoteManage',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		// Initialize the editor once when the form loads (if not already initialized)
		if (!tinymce.get('agentinvoicespecificnotemanage-agent_invoice_specific_note-note')) {
			Adzuki.Editor('#agentinvoicespecificnotemanage-agent_invoice_specific_note-note', {
				height: 400,
			});
		}

		// SET-83: .off() BEFORE .on(), AND THAT IS NOT DEFENSIVE TIDYING.
		//
		// On the legacy screen load() runs once per page. In the settings modal it runs on EVERY
		// panel render, through Adzuki.Form.initAjaxForm() - so a plain .on() stacks a second
		// handler the second time the advisor opens this form, and the quick-insert then pastes the
		// link twice. A third visit pastes it three times.
		//
		// Namespaced so this only detaches its own handler, and harmless on the legacy screen where
		// there is nothing to detach.
		$('.insert-form-link').off('click.invoiceNote').on('click.invoiceNote', function onClick(e) {
			var link_url = $(this).data('url'),
			    link_text = $(this).data('text'),
			    new_content,
			    editor;

			e.preventDefault();

			// Get the existing TinyMCE editor instance
			editor = tinymce.get('agentinvoicespecificnotemanage-agent_invoice_specific_note-note');

			// Insert content at the current cursor position
			new_content = '<a href="' + link_url + '" target="_blank">' + link_text + '</a>';
			editor.insertContent(new_content);
		});
	};
}(jQuery, window.Adzuki || {}));
